// Promotion State
import i18n from '@/i18n'

export default {
  promotionList: [],
  promotionInfo: {},
  customerRules: [{ text: i18n.t('All'), value: 'All' }, { text: i18n.t('Group'), value: 'Group' }],
  productRules: [
    { text: i18n.t('All'), value: 'All' },
    { text: i18n.t('Product Type'), value: 'Product Type' },
    { text: i18n.t('Specific Products'), value: 'Specific Products' }
  ],
  amountRuleTypes: [
    { text: i18n.t('Money Amount'), value: 'Money Amount' },
    { text: i18n.t('Item Quantity'), value: 'Item Quantity' }
  ],
  rewardTypes: [
    { text: i18n.t('Get Free'), value: 'Get Free' },
    { text: i18n.t('Get Discount'), value: 'Get Discount' },
    { text: i18n.t('Get Amount'), value: 'Get Amount' }
  ]
}
